import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { inRange, isEmpty, lowerCase } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import iconBkash from "../../assets/images/bkash.png";
import iconRocket from "../../assets/images/rocket.png";
import iconNagad from "../../assets/images/nagad.png";
import iconEth from "../../assets/images/eth.svg";
import iconBtc from "../../assets/images/btc.svg";
import iconUpay from "../../assets/images/upay.png";
import iconTrc20 from "../../assets/images/trc20.svg";
import { Form } from "react-bootstrap";
import { formatWithCommas, validationRules } from "../../Utils/Toast";
import { FaRegCopy } from "react-icons/fa";
import ReferenceDepositGuide from "./ReferenceDepositGuide";

const Deposit = ({ setTab, embedded = false }) => {
  const [showApplication, setShowApplication] = useState(false);
  const naviagte = useNavigate();
  let location = useLocation();
  const { offerCode } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    clearErrors,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      depositType: "online",
    },
  });

  const [image, setImage] = useState("");
  const [dataOffer, setDataOffer] = useState([]);
  const [bank, setBank] = useState([]);
  const [bankId, setBankId] = useState("");
  const { t } = useTranslation();
  const [fiexdOffer, setFixedOffer] = useState(0);
  const [isCopied, setCopied] = useState(false);
  const [minDeposit, setMinDeposit] = useState(100);
  const [maxDeposit, setMaxDeposit] = useState(25000);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const amountDeposit = useContextSelector(
    AuthContext,
    (ctx) => ctx.amountDeposit
  );
  const [isLoader, setLoader] = useState(false);
  const [offer, setOffer] = useState("");
  const [limit, setLimit] = useState(
    profileData?.limitSetting?.length > 0
      ? profileData?.limitSetting[0]
      : {
          minDeposit: "100",
          maxDeposit: "30000",
        }
  );

  const onSubmit = async (body) => {
    setLoader(true);
    let imageCheck = "";
    if (image !== "") {
      imageCheck = await uploadImage(image);
    }
    body = {
      transactionType: body?.depositType,
      amount: body?.amount,
      TransactionId: body?.transactionId,
      TransactionFile: image !== "" ? imageCheck : "",
      bank: bankId,
      AccountName: body?.accountName,
      BankAccount: body?.bankAccount,
      bonus: body?.bonus,
      payment: "online",
      offer: offer,
    };
    const { status, data } = await apiPost(apiPath.depositAmount, body);
    if (status == 200) {
      if (data?.success) {
        toast.success(data?.message);
        reset();
        setImage("");
      } else {
        toast.error(data?.message);
        setLoader(false);
      }
    } else {
      toast.error(data?.message);
      setLoader(false);
    }
    setLoader(false);
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "deposit",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(data?.results?.bankList);
        if (data?.results?.bankList?.length > 0) {
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const getBankDetail = async (body) => {
    setBankId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };

  const uploadImage = async (obj) => {
    let form = new FormData();
    form.append("TransactionFile", obj);
    const { status, data } = await apiPost(apiPath.reciptUpload, form);
    if (status == 200) {
      return data?.path;
    } else {
      return false;
    }
  };
  useEffect(() => {
    getBank();
    setValue("depositType", "online");
  }, []);

  useEffect(() => {
    if (amountDeposit?.check && amountDeposit?.amount > 0) {
      setValue("amount", amountDeposit?.amount);
    }
  }, [amountDeposit?.check]);

  let priceValue = 0;
  const priceCalculate = async (price) => {
    priceValue += price;
    setValue("amount", priceValue);

    const matchedOffer = dataOffer?.find((res) => res?._id == offer);

    if (matchedOffer?.variation?.length) {
      const match = matchedOffer.variation.find((item) => {
        const min = parseFloat(item.depositeVaritationMin);
        const max = parseFloat(item.depositeVaritationMax);
        return priceValue >= min && priceValue <= max;
      });

      if (match) {
        setFixedOffer(match.depositeVaritationPercentage);
      } else {
        setFixedOffer(0);
      }
    }
  };

  useEffect(() => {
    if (offer) {
      priceCalculate(getValues("amount"));
    }
  }, [offer]);

  const resetPrice = async () => {
    setValue("amount", "");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isCopied]);

  useEffect(() => {
    if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
      setMinDeposit(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.minDeposit
      );
      setMaxDeposit(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.maxDeposit
      );
    }
  }, [!isEmpty(profileData)]);
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional, {
      category: "Deposit",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.offerList?.filter((res) => {
          return res?.category == "Deposit";
        });
        let updated = getFilteredOfferList(
          profileData?.userDepositCount || 0,
          result
        );
        let find = updated?.find((res) => {
          return res?._id == offerCode;
        });
        if (!isEmpty(find)) {
          setOffer(find?._id);
          setLimit({
            minDeposit: find?.minimumDeposite,
            maxDeposit: find?.maximumDeposite,
          });
        }
        if (updated?.length > 0) {
          setDataOffer(updated);
        }
      }
    }
  };
  useEffect(() => {
    getData();
    setOffer(offerCode);
  }, [offerCode, profileData]);

    const handleCopy = () => {
    navigator.clipboard
      .writeText(watch("bankAccount"))
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const maskBankAccount = (value = "") => {
    if (!value) return "";
    const first4 = value.slice(0, 4);
    const masked = "*".repeat(Math.max(0, value.length - 4));
    return first4 + masked;
  };

  if (embedded && !showApplication) return <ReferenceDepositGuide banks={bank} onSelect={id => { getBankDetail(id); setValue("bank", id); }} onApply={amount => { if (amount) setValue("amount", amount); setShowApplication(true); }} setTab={setTab} />;

  return (
    <div className="reference-deposit-application">
      {embedded && <button type="button" className="reference-deposit-back" onClick={() => setShowApplication(false)}>‹ Deposit guide</button>}
      <div id="mc_container" className="EN">
        <div id="deposit">
          <ul
            className="clearfix ps"
            id="depositTab"
            style={{ overflow: "hidden" }}
          >
            {bank?.length > 0 &&
              bank?.map((res) => {
                return (
                  <li
                    onClick={() => {
                      getBankDetail(res?._id);
                      setValue("bank", res?._id);
                    }}
                    className={`nav-item ${bankId == res?._id ? "active" : ""}`}
                  >
                    <div
                      className="icon"
                      style={{
                        backgroundImage: `url(${
                          res?.bank_name.toLowerCase().includes("bkash")
                            ? iconBkash
                            : res?.bank_name.toLowerCase().includes("nagad")
                            ? iconNagad
                            : res?.bank_name.toLowerCase().includes("rocket")
                            ? iconRocket
                            : res?.bank_name.toLowerCase().includes("eth")
                            ? iconEth
                            : res?.bank_name.toLowerCase().includes("btc")
                            ? iconBtc
                            : res?.bank_name.toLowerCase().includes("upay")
                            ? iconUpay
                            : iconTrc20
                        })`,
                      }}
                    />
                    <div className="bankname">
                      <div>{res?.bank_name}</div>
                      <div className="rebate" />
                    </div>
                  </li>
                );
              })}
          </ul>
          <div className="deposit_container">
            <div className="deposit_title">
              <div className="txt" translate="label_deposit_info">
                Deposit Info
              </div>
              <div className="deposit-group">
                <div
                  onClick={() => setTab("accountRecord")}
                  className="deposit-records"
                >
                  <span className="book-icon" />
                  <span className="title" translate="label_deposit_history">
                    Deposit History
                  </span>
                  <span className="cashIn-count hide" />
                </div>
                <div className="deposit-teaching hide">
                  <span className="book-icon" />
                  <span className="title" translate="label_deposit_help">
                    How to Deposit?
                  </span>
                </div>
              </div>
            </div>

            {isLoader && <div className="mc-loading" />}
            <div
              id="deposit_wrp"
              className="right-panel-height "
              style={{ height: "525px" }}
            >
              <div id="mc_container" className="model_child_content">
                <div className="onPayment-Rtcontent-wrp inline-block width100">
                  <div className="onPayment-Rtcontent depositForm scroll-bar">
                    <Form
                      onSubmit={handleSubmit(onSubmit)}
                      id="PGMTForm"
                      noValidate
                      autoComplete="off"
                    >
                      <span className="bankMessage">
                        আপনাকে trxid পূরণ করতে হবে। আপনি যদি রিচার্জটি পূরণ না
                        করেন তবে রিচার্জটি জমা হবে না
                      </span>
                      <div id="PGMT">
                        <div className="dmc_accordionTab" id="accordionTab">
                          <div className="wap-op">
                            <div id="MobileVerifiedWrap">
                              {!isEmpty(bankId) && (
                                <>
                                  <div className="hag_register_commun hac_link_mangslc10 dmc_accordionTab depositNickname">
                                    <span className="hag_regcom_lt hag_reg_fc142">
                                      Account Name
                                    </span>
                                    <div className="hag_regcom_nameinp dmc_accordion_pr">
                                      <input
                                        type="text"
                                        disabled
                                        {...register("accountName")}
                                        className="form-control ch-input"
                                        placeholder="Nickname"
                                      />
                                    </div>
                                  </div>
                                  <div className="hag_register_commun hac_link_mangslc10 account-form" style={{ position: "relative" }}>
                                    <span
                                      className="hag_regcom_lt hag_reg_fc142 colon"
                                      translate="label_deposit_account"
                                    >
                                      Bank Account
                                    </span>
                                    <div className="hag_regcom_nameinp dmc_accordion_pr">
                                      <input
                                        type="text"
                                        disabled
                                        data-valid="account"
                                        className="form-control ch-input"
                                        placeholder="Deposit account"
                                        value={maskBankAccount(
                                          watch("bankAccount")
                                        )}
                                        {...register("bankAccount")}
                                      />
                                      <FaRegCopy
                                        onClick={() => handleCopy()}
                                        color="black"
                                        size={16}
                                        style={{
                                          position: "absolute",
                                          left: "115px",
                                          top: "0%",
                                        }}
                                    />
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="hag_register_commun hac_link_mangslc10 account-form deposit-idNumber">
                                <span
                                  className="hag_regcom_lt hag_reg_fc142 colon"
                                  translate="label_id"
                                >
                                  Transaction Id
                                </span>
                                <div className="hag_regcom_nameinp dmc_accordion_pr">
                                  <input
                                    type="text"
                                    name="idNumber"
                                    data-valid="idNumber"
                                    className="form-control ch-input"
                                    placeholder="Transaction Id"
                                    {...register("transactionId", {
                                      required: {
                                        value: true,
                                        message: "Please enter Transaction Id",
                                      },
                                      pattern: {
                                        value: validationRules.removeWhitespace,
                                        message:
                                          "Please enter only number or character",
                                      },
                                    })}
                                  />{" "}
                                  {errors?.transactionId?.message && (
                                    <div
                                      className="err-msg tcg-tooltip form-tooltip"
                                      style={{ display: "block" }}
                                    >
                                      <div
                                        className="err-cont"
                                        style={{ width: "auto !important" }}
                                      >
                                        <span className="rs-tri" />
                                        <span className="the-err-msg">
                                          {errors?.transactionId?.message}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="hag_register_commun hac_link_mangslc10 account-form">
                                <span
                                  className="hag_regcom_lt hag_reg_fc142 colon"
                                  translate="label_deposit_account"
                                >
                                  Upload Receipt
                                </span>
                                <div className="hag_regcom_nameinp dmc_accordion_pr">
                                  <input
                                    type="file"
                                    data-valid="account"
                                    className="form-control ch-input"
                                    onChange={(e) => {
                                      setImage(e.target.files[0]);
                                    }}
                                    accept="image/png, image/jiffy, image/jpeg, image/jpg"
                                  />{" "}
                                  {image !== "" && (
                                    <button
                                      style={{
                                        border: "none",
                                        borderRadius: "5px",
                                        background: "red",
                                        color: "white",
                                        padding: "5px",
                                        width: "40%",
                                        marginTop: "5px",
                                        fontWeight: "600",
                                        fontSize: "13px",
                                        marginLeft: "10px",
                                      }}
                                      onClick={() => setImage("")}
                                      type="button"
                                    >
                                      Remove Image
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="hag_register_commun hac_link_mangslc10">
                                <span
                                  className="hag_regcom_lt hag_reg_fc142 colon"
                                  translate="label_deposit_amount"
                                >
                                  Deposit Amounts
                                </span>
                                <div className="hag_regcom_nameinp dmc_accordion_pr">
                                  <div className="hag_deposit_famount dmc_deposit_famount">
                                    {AmountArray?.map((res) => {
                                      return (
                                        <span
                                          onClick={() =>
                                            priceCalculate(res?.amount)
                                          }
                                          style={{ boxShadow: "none" }}
                                          className={`default-wrap ${
                                            watch("amount") == res?.amount
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          {res?.amount}
                                          <div className="ticket hide" />
                                          <b className="bonus" />
                                        </span>
                                      );
                                    })}
                                  </div>
                                  <div className="input-wrap">
                                    <div className="input-wrapper">
                                      <input
                                        type="text"
                                        name="amount"
                                        data-valid="amount"
                                        className="form-control ch-input number-separator with"
                                        placeholder="Deposit Amounts"
                                        {...register("amount", {
                                          required: {
                                            message: "Please enter amount",
                                          },
                                          pattern: {
                                            value: /^[0-9]*$/,
                                            message:
                                              "Please enter valid number",
                                          },
                                          validate: (value) => {
                                            if (
                                              !inRange(
                                                value,
                                                limit?.minDeposit,
                                                limit?.maxDeposit
                                              )
                                            ) {
                                              return `Deposite amount should be in range of ${limit?.minDeposit} - ${limit?.maxDeposit}`;
                                            } else {
                                              return true;
                                            }
                                          },
                                        })}
                                      />
                                      {errors?.amount?.message && (
                                        <div
                                          className="err-msg tcg-tooltip form-tooltip"
                                          style={{ display: "block" }}
                                        >
                                          <div
                                            className="err-cont"
                                            style={{ width: "auto !important" }}
                                          >
                                            <span className="rs-tri" />
                                            <span className="the-err-msg">
                                              {errors?.amount?.message}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      <span className="ticket hide" />
                                      <span className="bonus-amount hide" />
                                    </div>{" "}
                                    <div className="amount-tip hide" />
                                  </div>
                                </div>
                                <div className="hag_validval amount_deposit_range">
                                  <span
                                    className="colon"
                                    translate="local_deposit_amount"
                                  >
                                    Deposit Limit
                                  </span>
                                  <span className="min_deposit">
                                    <span className="symbol front">৳</span>{" "}
                                    {formatWithCommas(minDeposit)}{" "}
                                  </span>
                                  <span className="max_deposit">
                                    <span className="symbol front">৳</span>{" "}
                                    {formatWithCommas(maxDeposit)}
                                  </span>
                                  <span
                                    className="amount_deposit_range hide"
                                    id="data_charges"
                                  >
                                    <span
                                      className="colon"
                                      translate="label_fee"
                                    >
                                      Transaction Fee
                                    </span>
                                    <span
                                      className="depost_charges"
                                      charges="0|0|0|0"
                                    >
                                      ---
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div className="hag_register_commun hac_link_mangslc10">
                                <span
                                  className="hag_reg_fc142 colon"
                                  translate="label_choose_promotion"
                                  id="deposit-promotion-title"
                                >
                                  Choose promotion
                                </span>
                                <div
                                  className="hag_regcom_nameinp "
                                  id="hag_reg"
                                >
                                  <input
                                    type="text"
                                    name="promotions"
                                    defaultValue
                                    data-value
                                    className="hide"
                                    readOnly="readonly"
                                    data-placeholder
                                    translate="label_have_promotion"
                                    placeholder="Choose promotion"
                                  />
                                  <div id="opTab1">
                                    <ul
                                      className="chosen-results1"
                                      id="depositAllPromotions"
                                    >
                                      {/* disabled */}
                                      {dataOffer?.map((res, index) => {
                                        return (
                                          <li
                                            onClick={() => {
                                              setOffer(res?._id); // triggers useEffect
                                              setLimit({
                                                minDeposit:
                                                  res?.minimumDeposite,
                                                maxDeposit:
                                                  res?.maximumDeposite,
                                              });
                                            }}
                                            className={`promotion-item ${
                                              offer == res?._id ? "active" : ""
                                            }`}
                                          >
                                            <div className="promo-top">
                                              <div className="promo-info">
                                                <div className="promName">
                                                  <span className="title">
                                                    {res?.title}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="minDeposit">
                                                <span>≥</span>
                                                <span className="symbol front">
                                                  ৳
                                                </span>{" "}
                                                {res?.minimumDeposite}.
                                                <small
                                                  style={{
                                                    "font-size": "70%",
                                                    color: "inherit",
                                                  }}
                                                >
                                                  00
                                                </small>
                                              </div>
                                            </div>{" "}
                                            {res?._id == offer && (
                                              <div className="promo-bottom">
                                                <div className="personal-info  ">
                                                  <div className="info-title">
                                                    *Reminder: Users who haven't
                                                    verify below info will not
                                                    receive bonus.
                                                  </div>
                                                  <div className="personal-info-item ">
                                                    <span className="item-title">
                                                      {" "}
                                                      Bind withdrawal account
                                                    </span>
                                                    {/* <div
                                                    className="item-btn"
                                                    data-target="bankCards"
                                                  >
                                                    Set up
                                                  </div> */}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                            <p className="proTips">
                                              <span className="proTips-content">
                                                {res?.description.substring(
                                                  0,
                                                  59
                                                )}
                                              </span>
                                            </p>
                                          </li>
                                        );
                                      })}
                                      <li
                                        onClick={() => {
                                          setOffer(""); // triggers useEffect
                                        }}
                                        className={`promotion-item default ${
                                          offer == "" ? "active" : ""
                                        } `}
                                      >
                                        <div className="promName">
                                          Do not participate in any promotions
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="remark hide" />
                                </div>
                              </div>
                              <div className="hag_register_commun hac_link_mangslc10">
                                <span className="hag_regcom_lt hag_reg_fc142" />
                                <div
                                  id="dmc_accordion_remark"
                                  className="dmc_accordion_remark"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="needMobileVerified" className="hide">
                          <div className="bg" />
                          <div className="desc">
                            <p translate="please_bind_mobile">
                              Please bind your mobile number to use deposit.
                            </p>
                          </div>
                          <div
                            className="btn go_to_bind_mobile"
                            translate="go_to_bind_mobile"
                          >
                            GO
                          </div>
                        </div>
                      </div>
                      <div className="red-btn-bottom">
                        <div className="mem-icon2 ">
                          <input
                            className="ch-overyd form-submit"
                            type="submit"
                            defaultValue="Apply for Deposit"
                            translate="button_confirm_application_for_deposit"
                            style={{}}
                            data-old-content
                          />
                        </div>
                      </div>
                    </Form>
                    <div
                      className="2kAlipay  defaultPageQrForm hide"
                      id="defaultPageQrForm"
                    />
                    <div
                      id="quickPaymentPostDeposit"
                      className="QuickPayment-Rltcontent row-3 inline-block rs-qckpymnt hide enable"
                    >
                      <div className="inline-block top-contner">
                        <div
                          className="tab-tile-sub-ch"
                          translate="label_confirm_deposit_info"
                        >
                          Confirm deposit request
                        </div>
                      </div>
                      <div className="QPayment-content clearfix">
                        <div className="rowTwo-wrp">
                          <div className="po-middle">
                            <div
                              className="inline-block po-middleL colon"
                              translate="label_deposit_amount"
                            >
                              Deposit Amounts
                            </div>
                            <div className="inline-block po-middle mg-fix1">
                              <input
                                id="deposit_amount"
                                className="ch-overyd"
                                type="text"
                                defaultValue
                                readOnly
                                translate="label_deposit_amount"
                                placeholder="Deposit Amounts"
                              />
                            </div>
                          </div>
                          <div className="inline-block po-middle">
                            <input
                              data-clipboard
                              data-clipboard-target="deposit_amount"
                              className="mem-icon2 ctie-btn po-middle"
                              type="button"
                              defaultValue="Copy"
                              translate="label_copy"
                            />
                          </div>
                        </div>
                        <div className="rowTwo-wrp">
                          <div className="po-middle">
                            <div
                              className="inline-block po-middleL colon"
                              translate="label_payee_account_name"
                            >
                              Payee account name
                            </div>
                            <div className="inline-block po-middle mg-fix1">
                              <input
                                id="accountNumber"
                                className="ch-overyd"
                                type="text"
                                defaultValue
                                readOnly
                                translate="mc_deposit_qp_post_payeename_placeholder"
                                placeholder="mc_deposit_qp_post_payeename_placeholder"
                              />
                            </div>
                          </div>
                          <div className="inline-block po-middle">
                            <input
                              data-clipboard
                              data-clipboard-target="accountNumber"
                              className="mem-icon2 ctie-btn po-middle"
                              type="button"
                              defaultValue="Copy"
                              translate="label_copy"
                            />
                          </div>
                        </div>
                        <div className="rowTwo-wrp">
                          <div className="po-middle ">
                            <div
                              className="inline-block po-middleL colon"
                              translate="pgmt_title_bank"
                            >
                              Bank name
                            </div>
                            <div className="inline-block po-middlec mg-fix1">
                              <input
                                id="bank_name"
                                className="ch-overyd"
                                type="text"
                                defaultValue
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="inline-block po-middle">
                            <input
                              data-clipboard
                              data-clipboard-target="bank_name"
                              className="mem-icon2 ctie-btn po-middle"
                              type="button"
                              defaultValue="Copy"
                              translate="label_copy"
                            />
                          </div>
                        </div>
                        <div className="rowTwo-wrp">
                          <div className="po-middle">
                            <div
                              className="inline-block po-middleL colon"
                              translate="pgmt_title_payee"
                            >
                              Payee
                            </div>
                            <div className="inline-block po-middlec mg-fix1">
                              <input
                                id="bankCardName"
                                className="ch-overyd"
                                type="text"
                                defaultValue
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="inline-block po-middle">
                            <input
                              data-clipboard
                              data-clipboard-target="bankCardName"
                              className="mem-icon2 ctie-btn po-middle"
                              type="button"
                              defaultValue="Copy"
                              translate="label_copy"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mem-icon2 red-border-bh pop">
                        <input
                          className="form-reset hide"
                          type="reset"
                          defaultValue="Reset Form"
                        />
                        <input
                          className="ch-overyd form-submit openBankUrl"
                          id="openBankUrl"
                          type="button"
                          defaultValue="Return"
                          translate="label_return"
                          style={{}}
                          data-old-content
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bankcardMask hide">
          <div className="content">
            <div className="title" translate="label_tips_text">
              Tips
            </div>
            <div className="tips" translate="info_bind_card_first">
              Please bind bank account before using deposit function.
            </div>
            <div className="line" />
            <div className="btn" id="bindCard" translate="go_bind_card">
              GO
            </div>
          </div>
        </div>
        <div className="mobileMask hide">
          <div className="content">
            <div className="title" translate="label_tips_text">
              Tips
            </div>
            <div className="tips">
              <p translate="please_bind_mobile_first">
                Please bind your mobile number or choose other channel.
              </p>
            </div>
            <div className="line" />
            <div className="btn-group">
              <div className="cancel" translate="button_cancel">
                Cancel
              </div>
              <div
                className="btn"
                id="bindMobile"
                translate="go_to_bind_mobile"
              >
                GO
              </div>
            </div>
          </div>
        </div>
        <div className="allowDepositMask hide">
          <div className="content">
            <div className="title" translate="label_tips_text">
              Tips
            </div>
            <div className="tips" translate="unallowed_deposit">
              Deposit is currently not available, please try again later.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deposit;

// svg-loading
export const AmountArray = [
  { id: 1, amount: 300 },
  { id: 2, amount: 500 },
  { id: 3, amount: 1000 },
  { id: 4, amount: 5000 },
  { id: 5, amount: 15000 },
  { id: 6, amount: 20000 },
  { id: 7, amount: 25000 },
];
